<template>
  <div class="wrapper">
    <side-bar />
    <div id="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script type="text/javascript">
import { SideBar } from '@/components'

export default {
  name: 'Home',
  components: { SideBar }
}
</script>

<style scoped></style>
